let api = {
    endpoint:'/api/v1/',
    getLections(params){
        this.request('getLections',params,this.endpoint + 'lection')
    },
    getActiveSream(id) {
        this.request('getLections',params, this.endpoint + `activity/confirmation/active${id}`)
    },
//{{url}}/api/v1/activity/confirmation/active?lection_id=2256
    request(action,params,url) {
        for (var propName in params) {
            if (params[propName] === null || params[propName] === undefined) {
                delete params[propName];
            }
        }
        try {
            $.ajax({
                url: url,
                dataType: "json",
                data:params,
                success: function (data) {
                    document.dispatchEvent(new CustomEvent(action, {
                        bubbles: true,
                        detail: data
                    }));
                },
                fail: function () {

                    throw new Error('Ошибка получении данных');

                }
            });

        } catch (e) {
            //Отправить данные об ошибке в систему логов
            console.error(e);
        }
    }
};